import { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { AppRouter } from './core/routes/AppRouter'
import { useVersionCheck } from 'utils/useVersionCheck'

function App() {
  useVersionCheck()
  return (
    <BrowserRouter>
      <Suspense fallback={''}>
        <AppRouter />
      </Suspense>
    </BrowserRouter>
  )
}

export default App
